import { issueTypes } from '../constants/issueTypes';
import { withTranslation } from './withTranslation';

export const getConcatIssueLabels = (labels: string[]): string => {
  const issueLabels = issueTypes
    .filter((type) => labels?.includes(type?.type))
    .map((i) => withTranslation('reportIssue', i.label));
  return issueLabels.join('; ');
};

export const getConcatIssueLabelsFull = (labels: string[]): string => {
  const issueLabels = issueTypes
    .filter((type) => labels.includes(type.type))
    .map((i) => withTranslation('reportIssue', i.label));
  return withTranslation('reportIssue', 'issueType') + issueLabels.join('; ');
};
